import clsx from 'clsx'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import { Trans } from '@lingui/react/macro'

import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { EncodedRouteLink } from '@jotta/ui/EncodedRouterLink'
import SvgFillCaretDown from '@jotta/ui/SvgFillCaretDown'
import { cn } from '@jotta/utils/css'

import { useFileRouteParams } from '../FileRoute/utils/getFileRouteParams'
import type { FolderStore } from '../Folder/FolderStore'

import { FileBrowserToolbar } from './FileBrowserToolbar'

import styles from '../PathItem/PathItemRow.module.scss'

const debug = Debug('jotta:files:PathItemRow')
export const FileBrowserHeader = observer<{
  store: FolderStore
}>(function FileBrowserHeader({ store }) {
  const { context } = useFileRouteParams()
  const isSearch = context === 'search'
  const { selection, hasSelection: checked } = store

  return (
    <div className="sticky top-0 z-appMainDataTableHeader flex flex-col border-b border-light bg-primary">
      <FileBrowserToolbar folder={store} />
      <div
        className={cn(styles.row, styles.header, 'viewmodelist')}
        data-testid="FolderViewHeader"
        data-header
      >
        <label className={styles.checkbox}>
          <input
            ref={selection.headerInputRef}
            type="checkbox"
            checked={checked}
            onChange={selection.toggleSelectAll}
          />
        </label>

        <div className={styles.rowData}>
          <div className={styles.icon} />
          <div
            data-testid="FolderSortByName"
            aria-selected={store.route.sortColumn === 'name'}
            className={clsx(styles.link, styles.sortLink, {
              [styles.desc]: store.route.sortDescending,
              [styles.activeSortLink]: store.route.sortColumn === 'name',
            })}
          >
            <EncodedRouteLink
              to={store.route.sortLinks.name.to}
              replace={isSearch}
            >
              <span>
                <Trans>Name</Trans>
              </span>
              <PlainBrandIcon icon={SvgFillCaretDown} />
            </EncodedRouteLink>
          </div>

          <div
            data-testid="FolderSortByModified"
            aria-selected={store.route.sortColumn === 'modified'}
            className={clsx(styles.dateHeader, styles.sortLink, {
              [styles.desc]: store.route.sortDescending,
              [styles.activeSortLink]: store.route.sortColumn === 'modified',
            })}
          >
            <EncodedRouteLink
              to={store.route.sortLinks.modified.to}
              replace={isSearch}
            >
              <span>
                <Trans>Modified</Trans>
              </span>
              <PlainBrandIcon icon={SvgFillCaretDown} />
            </EncodedRouteLink>
          </div>
          <div
            data-testid="FolderSortBySize"
            aria-selected={store.route.sortColumn === 'size'}
            className={clsx(styles.sizeHeader, styles.sortLink, {
              [styles.desc]: store.route.sortDescending,
              [styles.activeSortLink]: store.route.sortColumn === 'size',
            })}
          >
            <EncodedRouteLink
              to={store.route.sortLinks.size.to}
              replace={isSearch}
            >
              <span>
                <Trans>Size</Trans>
              </span>
              <PlainBrandIcon icon={SvgFillCaretDown} />
            </EncodedRouteLink>
          </div>
          <div className={styles.type}>
            <Trans>Type</Trans>
          </div>
        </div>
      </div>
    </div>
  )
})
